/* eslint-disable no-use-before-define */

import globalApps from '@bingads-webui-clientcenter/global-apps';
import { getUrlBuilders } from '@bingads-webui-clientcenter/url-builder-base';

const { pageContext, config } = globalApps;
const ccBaseUrl = (config && config.get('CCBaseUrl')) || '';

const UrlBuilders = getUrlBuilders({
  ccBaseUrl,
  getDefaultIsShortUrl: () => true,
  aidFetcher: () => pageContext.aid,
  cidFetcher: () => pageContext.cid,
  uidFetcher: () => pageContext.uid,
});

export default UrlBuilders;
